import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { AudioPlayerProvider } from "./contexts/AudioPlayerContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AudioPlayerProvider>
        <App />
      </AudioPlayerProvider>
    </Provider>
  </React.StrictMode>
);
